import { render } from "./componentPicker.vue?vue&type=template&id=22fdf126&scoped=true&lang=pug"
import script from "./componentPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./componentPicker.vue?vue&type=script&setup=true&lang=js"

import "./componentPicker.vue?vue&type=style&index=0&id=22fdf126&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-22fdf126"

export default script